<template>
  <div id="app">
    <!-- <keep-alive> -->
       <router-view/>
    <!-- </keep-alive> -->
  </div>
</template>
<script>
import { getUserPower } from './utils/power'
export default {
  async created () {
    getUserPower()
  }
}
</script>

<style lang="scss">
@import './rich.scss';
* {
  margin: 0;
  padding: 0;
}
.home, .page  {
  max-width: 100vw;
  height: 100vh;
}
.card {
  position: relative;
}
span {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.w-e-toolbar .w-e-menu {
  z-index: 9 !important;
}
.w-e-text-container {
  z-index: 5 !important;
}
</style>
